export default class OnsaleTimer {
    constructor() {
        this.onsaleStartedContainer = document.getElementById("onsale-started");
        if (this.onsaleStartedContainer == null) return;
        const value = this.onsaleStartedContainer.dataset.secondsToStart;
        this.secondsLeft = parseFloat(value);

        if (isNaN(this.secondsLeft)) return;

        this.init();
    }

    init() {
        this._countDown();
    }

    _countDown() {
        if (this.secondsLeft <= 0) {
            this.onsaleStartedContainer.classList.remove("d-none");
            return;
        }
        this.secondsLeft--;
        setTimeout(() => this._countDown(), 1000);
    }
}
